import "./header.css"
import * as React from "react"
import { Link } from "react-router-dom"
import { Menu } from '@mui/icons-material'
import { useTranslation } from "react-i18next"
import img_logo from "../images/logo.svg";

export const header_height = 4.8

type ButtonBaseProp = {
  label: string,
  colorClass: string,
};

type ButtonIProps = (ButtonBaseProp & {to: string}) | (ButtonBaseProp & {href: string});

const transparent_color = {textClass: "text-light", headerBgColor: "#0000", modalBgClass: "bg-dark"}
const translucent_color = {textClass: "text-dark", headerBgColor: "#fffD", modalBgClass: "bg-light"}

const HeaderLink = (props: {children: React.ReactNode, className: string, to?: string, href?: string}) => (
  props.to ? (
    <Link className={props.className} to={props.to}>{props.children}</Link>
  ) : (
    <a className={props.className} href={props.href}>{props.children}</a>
  )
);

function HeaderButton(props: ButtonIProps) {
  const {colorClass, label, ...linkProps} = props;
  return (
    <HeaderLink className={`text-decoration-none d-flex flex-column justify-content-center align-items-center my-4 my-md-0 text-light animation-border-bottom ${colorClass}`} {...linkProps}>
      <p className="text-center m-0 px-3 h6">{label}</p>
    </HeaderLink>
  );
}

const getBoundary = (path: string) => (path === "/" ? 0.8 : 0.1)

export const Header: React.FC<{path: string}> = ({path}) => {
  const [color, setColor] = React.useState(transparent_color)
  const [menu, setMenu] = React.useState(true)
  const [open, setOpen] = React.useState(false)
  const { t } = useTranslation("translations") 

  const buildLang = document.documentElement.lang || 'ja';
  const otherLangLink = buildLang === 'ja' 
    ? `https://global.mksc.jp${path}` 
    : `https://www.mksc.jp${path}`;
  const otherLangLabel = buildLang === 'ja' ? 'English' : '日本語';

  //TODO: 汚いのでなおしたい
  const event_scroll_handler = () => {
    if ((typeof window !== "undefined") && window.scrollY > (window.innerHeight * getBoundary(path))) {
      if (color !== translucent_color) setColor(translucent_color)
    } else {
      if (color !== transparent_color) setColor(transparent_color)
    }
  }
  const event_responsive_handler = () => {
    if ((typeof window !== "undefined") && window.innerWidth < 648) {
      menu && setMenu(false)
    } else {
      !menu && setMenu(true)
    }
  }

  event_scroll_handler()
  event_responsive_handler()

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", event_scroll_handler)
    window.addEventListener("resize", event_responsive_handler)
  }
  //TODO: 汚いのでなおしたい

  const Items = () => (
    <>
      <HeaderButton label={t("HEADER.TOP")} colorClass={color.textClass} to="/" />
      <HeaderButton label={t("HEADER.SERVICE")} colorClass={color.textClass} to="/services" />
      <HeaderButton label={t("HEADER.PRODUCTS")} colorClass={color.textClass} to="/products" />
      <HeaderButton label={t("HEADER.AUTONOMOUS_VEHICLE")} colorClass={color.textClass} to="/autonomous-vehicle" />
      <HeaderButton label={t("HEADER.WORKS")} colorClass={color.textClass} to="/works" />
      <HeaderButton label={t("HEADER.COMPANY_INFO")} colorClass={color.textClass} to="/company-info" />
      <HeaderButton label={t("HEADER.LOCATIONS")} colorClass={color.textClass} to="/locations" />
      <HeaderButton label={t("HEADER.EMPLOYMENT")} colorClass={color.textClass} to="/employment" />
      <HeaderButton label={t("HEADER.TECH_BLOG")} colorClass={color.textClass} href="https://blog.mksc.jp" />
      <HeaderButton label={t("HEADER.CONTACT")} colorClass={color.textClass} to="/#contact" />
      <HeaderButton label={otherLangLabel} colorClass={color.textClass} href={otherLangLink} />
    </>
  )

  return (
    <>
      {!menu && open && (
        <div className="animation-slide-in d-flex position-fixed w-100 h-100 p-3" style={{zIndex: 999999, backgroundColor: "#111d"}} onClick={() => setOpen(false)}>
          <div className={`w-100 my-auto d-flex flex-column align-items-around shadow ${color.modalBgClass}`}>
            <Items />
          </div>
        </div>
      )
      }
      <header className="transition-500ms px-3 d-flex justify-content-between align-items-center w-100 fixed-top" style={{height: `${header_height}rem`, backgroundColor: color.headerBgColor}}>
        <Link to="/">
          <img src={img_logo} style={{height: `${header_height * 0.5}rem`}} alt="header-logo" />
        </Link>
        {menu && !open ?
         <div className="w-100 d-flex justify-content-end"><Items /></div>
        :
         <div className={`w-100 d-flex justify-content-end align-items-center ${color.textClass}`}>
           <Menu fontSize="medium" onClick={() => setOpen(!open)}/>
         </div>
        }
      </header>
    </>
  )
}
